import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import Title from '../../commonComponents/Title';
import SubHeader from '../../commonComponents/pageLayout/SubHeader';
import translate from '../../commonComponents/translate';
import ContentContainer from '../../commonComponents/pageLayout/ContentContainer';
import TopicBanner from '../../commonComponents/pageLayout/header/TopicBanner';
import MySessions from './MySessions';
import LoggedUserContext from '../../contextProviders/LoggedUserContext';
import CountryProp from '../../commonComponents/forms/Address/CountryProp';

function MySessionWrapper(props) {
  const { t, languages } = props;
  // Get the logged user
  const { loggedUser } = useContext(LoggedUserContext);

  return (
    <Title title={t('mySessions_head_title')}>
      <ContentContainer>
        <SubHeader title={t('mySessions_title')} />
        <TopicBanner />
        <div className="m-content">
          <div className="row full-page-container-with-subheader">
            <div className="col-lg-12">
              <MySessions loggedUser={loggedUser} languages={languages} />
            </div>
          </div>
        </div>
      </ContentContainer>
    </Title>
  );
}

MySessionWrapper.propTypes = {
  /** Translation function */
  t: PropTypes.func.isRequired,
  languages: PropTypes.arrayOf(PropTypes.shape(CountryProp.propType))
    .isRequired,
};

export default translate(MySessionWrapper);
